module.exports = __webpack_public_path__ + "img/blessing_prize_1.bdefcc58.png";